import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import PhoneInput from 'react-phone-number-input'

import api from "assets/services/api";
import { func } from 'prop-types';

function ModalAddContacts(props) {

    const { storageId } = useAuth();

    const [br, setBR] = useState(false);
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [name, setName] = useState("");
    const [type, setType] = useState("");
    const [id_client, setId_client] = useState(props.props)
    const [controlSnack, setControlSnack] = useState(false);
    const [types, setTypes] = useState(["COMPRAS", "FINANCEIRO", "RESPONSAVEL"])

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

   

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    useEffect(()=>{
        setType(types[0])
    },[])

    

    async function handleAddContacts(e) {
        e.preventDefault();
        const response = await api.post('/client/add/contact', {
            name: name,
            number: number,
            type: type,
            email: email,
            id_client: id_client
        });

        setName("")
        setNumber("")
        setEmail("")
        setControlSnack(true);
        props.loadContacts();
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar contato para { }
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddContacts}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control onChange={event => setName(event.target.value)} value={name} type="string" placeholder="Nome" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <PhoneInput
                                defaultCountry="BR"
                                className="form-control"
                                placeholder="Contato compras"
                                value={number}
                                onChange={(phoneNumber) => {
                                    setNumber(phoneNumber)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Email</Form.Label>
                            <Form.Control onChange={event => setEmail(event.target.value)} value={email} type="string" placeholder="Email" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Control onChange={(event) => {
                                setType(event.target.value)
                            }} value={type} as="select" defaultValue="...ChooseValue">
                                {types.map(type => (
                                    <option key={String(type)} value={type}>{type}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>

                    </Form.Row>

                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            ADICIONAR
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Contato atualizado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
export default ModalAddContacts;